import { gsap } from '../../../node_modules/gsap';
import { ScrollTrigger } from '../../../node_modules/gsap/ScrollTrigger';

export default {
  initHeroImages() {
    if (document.querySelector('.hero__media')) {
      gsap.registerPlugin(ScrollTrigger);
      const heroMedia = document.querySelector('.hero__media');
      const mainImage = document.querySelector('.hero__media-img--main');
      const leftTopImage = document.querySelector('.hero__media-img--left-top');
      const rightTopImage = document.querySelector(
        '.hero__media-img--right-top'
      );
      const leftBottomImage = document.querySelector(
        '.hero__media-img--left-bottom'
      );
      const rightBottomImage = document.querySelector(
        '.hero__media-img--right-bottom'
      );

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: heroMedia,
          start: 'bottom bottom',
          end: 'bottom top',
          scrub: true
        }
      });

      tl.to(mainImage, {
        y: -45
      });
      tl.to(
        leftTopImage,
        {
          y: -20
        },
        '<'
      );
      tl.to(
        rightTopImage,
        {
          y: -20
        },
        '<'
      );
      tl.to(
        leftBottomImage,
        {
          y: -60
        },
        '<'
      );
      tl.to(
        rightBottomImage,
        {
          y: -50
        },
        '<'
      );
    }
  }
};
